module.exports = __webpack_public_path__ + "img/932213419.965ab9a7.jpg";